import React, { useState } from "react";
import { Link } from "react-router-dom";
import expand from "../../assets/icons/expand.svg";
import { navLinks } from "../../mock/data";
import CloseMobileNav from "../svgs/CloseMobileNav";
import DesktopLogo from "../svgs/DesktopLogo";
import Hamburger from "../svgs/Hamburger";
import Whitedropdown from "../svgs/Whitedropdown";

const Header = () => {
  const [showDropDown, setShowDropDown] = useState(false);

  const handleDropdown = () => setShowDropDown(!showDropDown);

  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <>
     

      <header className="w-full bg-white flex items-center justify-between py-6 px-4 sm:px-10 xl:px-28">
        <Link to="/" className="w-auto relative">
          <DesktopLogo />
        </Link>

        <nav className="hidden lg:flex">
          <ul
            className="flex gap-6 xl:gap-10 font-light"
            style={{ color: "#000000" }}
          >
            {navLinks.map((items, idx) => (
              <li
                key={idx}
                className="relative cursor-pointer flex items-center gap-4 "
                onClick={items.subMenu ? handleDropdown : null}
              >
                <Link to={items.url}>{items.label}</Link>

                {items.subMenu && (
                  <span onClick={handleDropdown}>
                    <img src={expand} alt="" />
                  </span>
                )}

                {items.subMenu && showDropDown && (
                  <div className="shadowBg absolute w-[300px] top-full rounded-lg p-3  z-50 bg-white">
                    <div className="h-full flex flex-col p-2 ">
                      {items.subMenu.map((link, index) => (
                        <Link
                          to={link.url}
                          key={index}
                          className={`cursor-pointer flex items-center  ${
                            index !== 0 ? "border-t py-2" : " pb-2"
                          }`}
                        >
                          <img src={link.icon} alt={"icn"} className="w-8" />
                          <div className="flex flex-col ml-3">
                            <Link
                              className="text-[15px] font-[400]"
                              to={link.url}
                            >
                              {link.label}
                            </Link>
                            <span className="text-[11px] text-[#7F8287]">
                              {link.subLabel}
                            </span>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex items-center font-medium gap-4">
          <Link to="https://app.sleengshort.com/login">
            <button className="bg-primary text-white text-xs md:text-lg rounded-lg px-6 py-3">
              Login
            </button>
          </Link>
        </div>

        {/* <MobileMenu /> */}
        <button
          onClick={toggleMenu}
          className="border border-primary p-2 rounded-full md:hidden"
        >
          <Hamburger />
        </button>

        {isOpen && (
          <>
            {/* Overlay (optional) */}
            <div
              className="fixed top-0 left-0 w-full h-full bg-primary bg-opacity-50 z-40 backdrop-blur-sm"
              onClick={toggleMenu}
            />

            {/* Top Panel instead of Fullscreen */}
            <div className="fixed top-0 left-0 w-full h-[400px] z-50">
              <div className="w-full h-full bg-primary bg-opacity-90 backdrop-blur-3xl flex flex-col items-center px-6 py-4">
                {/* Close Button */}
                <div className="mb-4 self-end" onClick={toggleMenu}>
                  <CloseMobileNav />
                </div>

                {/* Navigation */}
                <nav className="w-full">
                  <ul className="flex flex-col gap-4 font-medium text-white w-full">
                    {navLinks.map((item, idx) => (
                      <li key={idx} className="cursor-pointer font-bold w-full">
                        <div
                          className="flex items-center justify-between w-full"
                          onClick={() => {
                            if (item.subMenu) {
                              handleDropdown();
                            } else {
                              toggleMenu();
                            }
                          }}
                        >
                          <Link to={item.url}>{item.label}</Link>
                          {item.subMenu && <Whitedropdown />}
                        </div>

                        {/* Stacked Submenu */}
                        {item.subMenu && showDropDown && (
                          <div className="mt-2 bg-white text-[#0050ae] rounded shadow p-4 w-full">
                            <div className="flex flex-col gap-2">
                              {item.subMenu.map((link, index) => (
                                <Link
                                  key={index}
                                  to={link.url}
                                  className="hover:underline"
                                  onClick={() => {
                                    toggleMenu();
                                    setShowDropDown(false);
                                  }}
                                >
                                  {link.label}
                                </Link>
                              ))}
                            </div>
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          </>
        )}
      </header>
    </>
  );
};

export default Header;
